/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional user feature flag required to create slots or bind tasks to this event kind. When None, the event kind is available to all permitted users.
 */
export type EventKindRequiredFeatureFlag = string | null;
